
export const thresholds = {
    lg: 1400,
    sm: 1024,
    xs: 568
}